(function() {
    let navbar = $('#navbar')
    let previousWindowScrollTop
    
    showNavbar()

    $(window).on({
        scroll: onScroll
    });

    function hideNavbar() {
        navbar.addClass('navbar--hidden')
    }

    function showNavbar() {
        navbar.removeClass('navbar--hidden')
    }
    
    function onScroll() {
        let documentHeight = $(document).height()
        let windowHeight = $(window).height()
        let windowScrollTop = $(window).scrollTop()
        let navbarHeight = navbar.height()

        windowScrollTop < navbarHeight || windowScrollTop + windowHeight >= documentHeight - 200 ? showNavbar() : windowScrollTop > previousWindowScrollTop ? hideNavbar() : showNavbar()

        previousWindowScrollTop = windowScrollTop;
    }
})()
